import { Inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IHttpClientService } from '../../../interfaces/index';
import { UserAccessResponseModel } from '../../../models';
import { GetConfig } from 'src/app/library-modules/auth-config.module';

@Injectable()
export class GetUserAccessUseCase {
    constructor(@Inject('IHttpClientService') private httpService: IHttpClientService) { }

    execute(): Observable<UserAccessResponseModel> {
        return this.httpService.get(GetConfig().serviceRootUrl+'/api/Authorization', new HttpParams());
    }
}
